import { Form, Radio } from "antd";
import moment from "moment";

const runTypeOptions = [
  { label: "Run Once", value: true },
  { label: "Recurring", value: false },
];

export default function ({ form, field, setRunOnce, disabled }) {
  const handleChange = (newValue) => {
    setRunOnce(newValue)
    const crons = form.getFieldValue("crons") || [];
    crons[field.name].runOnce = newValue;

    if (!newValue) {
      crons[field.name].cron = undefined
      crons[field.name].firstRun = moment()
      form.setFieldsValue({ crons });
    }
  };

  return (
    <Form.Item
      label="Run Type"
      name={[field.name, "runOnce"]}
      rules={[{ required: true, message: "Select a schedule type" }]}
    >
      <Radio.Group
        onChange={({ target: { value }}) => handleChange(value)}
        disabled={disabled}
      >
        {
          runTypeOptions.map((option) =>
            <Radio
              key={option.value}
              value={option.value}
            >
              {option.label}
            </Radio>
          )
        }
      </Radio.Group>
    </Form.Item>
  )
};
